import { Link } from 'react-router-dom'

import moment from 'moment'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'
import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

import styles from './index.module.css'

interface Props {
  event: CalendarEvent
  employeeId: string
  withDates: boolean
}

const EmployeeEvent = ({ event, employeeId, withDates }: Props) => {
  const { navigation } = useNavigation()

  const getName = (employee: Employee): string => {
    const userId = employee.attributes.access_id
    const user = users.get(userId)
    if (!user) {
      throw Error(`Error getting users with id = ${userId}`)
    }
    const name = getFullDisplayName({
      firstName: user.attributes.first_name,
      lastName: user.attributes.last_name,
      canSharePreferredName: employee.policy.can('sharePreferredName'),
      preferredName: employee.attributes.preferred_name,
    })
    if (withDates) {
      const day = moment(event.attributes.date).format('dddd')
      return i18n.t('calendar.event_date_with_name', {
        name,
        day,
      })
    } else {
      return name
    }
  }

  const employee = employees.get(employeeId)

  if (!employee) return null

  if (!employee.policy.can('readLeaves')) {
    return (
      <div className={styles.item}>
        <span>{getName(employee)}</span>
      </div>
    )
  }

  const to = navigation.employees.id.timeOff.fullPath({ id: employee.attributes.id })

  return (
    <Link to={to} className={styles.link}>
      <span>{getName(employee)}</span>
    </Link>
  )
}

export default observer(EmployeeEvent)
